// extracted by mini-css-extract-plugin
module.exports = {"expandable-text__text":"expandable-text_expandable-text__text__LU238","expandable-text__read-more":"expandable-text_expandable-text__read-more__FSqFR"};